import { Component, OnInit, HostBinding } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { ChangePasswordDialogComponent } from './features/auth/change-password-dialog/change-password-dialog.component';
import { AuthService } from './core/services/auth.service';
import { AdminSecurityDialogComponent } from './features/admin/admin-security-dialog/admin-security-dialog.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule, RouterOutlet, RouterLink, RouterLinkActive,
    MatToolbarModule, MatButtonModule, MatIconModule,
    MatSidenavModule, MatListModule, MatDialogModule
  ],
  template: `
    <div class="app-shell" [class.dark]="isDark" [class.light]="!isDark">
      <ng-container *ngIf="auth.isLoggedIn() && !isLanding()">
        <header class="app-toolbar">
          <button class="hamburger-btn" (click)="toggleSidenav()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>

          <span class="toolbar-brand">Administration</span>

          <span class="toolbar-spacer"></span>

          <div class="toolbar-user">
            <div class="user-avatar">{{ (auth.currentUser?.username || 'A')[0] | uppercase }}</div>
            <span class="user-name">{{ auth.currentUser?.username }}</span>
          </div>

          <button class="toolbar-btn" (click)="toggleTheme()" [title]="isDark ? 'Mode clair' : 'Mode sombre'">
            <svg *ngIf="isDark" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
            <svg *ngIf="!isDark" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
          </button>

          <button class="toolbar-btn" (click)="auth.logout()" title="Déconnexion">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          </button>
        </header>

        <div class="app-body">
          <aside class="app-sidebar" [class.open]="sidenavOpen">
            <div class="sidebar-header">
              <div class="sidebar-brand-icon">
                <img src="assets/logo-official-transparent-v2.png" alt="LAR">
              </div>
              <span class="sidebar-brand-text">Administration</span>
            </div>
            <nav class="sidebar-nav">
              <div class="sidebar-group-label">Principal</div>

              <a routerLink="/home" routerLinkActive="active-link" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                <span>Accueil</span>
              </a>

              <a routerLink="/dashboard" routerLinkActive="active-link" *ngIf="auth.isAdmin()" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
                <span>Performances</span>
              </a>

              <a routerLink="/ia-bilan" routerLinkActive="active-link" *ngIf="auth.isAdmin()" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                <span>Bilan IA</span>
              </a>

              <a routerLink="/vehicle-profitability" routerLinkActive="active-link" *ngIf="auth.isAdmin()" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                <span>Bilan Voitures</span>
              </a>

              <div class="sidebar-group-label">Gestion</div>

              <a routerLink="/catalogue" routerLinkActive="active-link" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                <span>Catalogue</span>
              </a>

              <a routerLink="/vehicles" routerLinkActive="active-link" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
                <span>Flotte</span>
              </a>

              <a routerLink="/clients" routerLinkActive="active-link" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                <span>Clients</span>
              </a>

              <a routerLink="/reservations" routerLinkActive="active-link" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                <span>Locations</span>
              </a>

              <div class="sidebar-group-label">Administration</div>

              <a routerLink="/expenses" routerLinkActive="active-link" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14l2.5-1.5L8 21l2.5-1.5L13 21l2.5-1.5L17 21z"/><path d="M9 1v4"/><path d="M13 1v4"/></svg>
                <span>Dépenses</span>
              </a>

              <a routerLink="/leasing" routerLinkActive="active-link" *ngIf="auth.isAdmin()" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
                <span>Leasing</span>
              </a>

              <a routerLink="/accidents" routerLinkActive="active-link" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                <span>Sinistres</span>
              </a>

              <a routerLink="/other-revenues" routerLinkActive="active-link" *ngIf="auth.isAdmin()" class="sidebar-link" (click)="closeMobile()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                <span>Autres Revenus</span>
              </a>

              <div class="sidebar-spacer"></div>

              <a (click)="openAdminSecurity()" *ngIf="auth.isAdmin()" class="sidebar-link" style="cursor:pointer">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                <span>Mots de Passe</span>
              </a>
            </nav>
          </aside>

          <div class="sidebar-overlay" [class.open]="sidenavOpen && isMobile" (click)="sidenavOpen = false"></div>

          <main class="app-main">
            <router-outlet></router-outlet>
          </main>
        </div>
      </ng-container>

      <ng-container *ngIf="!auth.isLoggedIn() || isLanding()">
        <router-outlet></router-outlet>
      </ng-container>
    </div>
  `,
  styles: [`
    :root { --theme-transition: 0.3s; }

    .app-shell { display: contents; }

    /* ═══ DARK THEME ═══ */
    .dark {
      --bg-body: #f0f7ff;
      --bg-toolbar: rgba(255, 255, 255, .95);
      --border-toolbar: rgba(20, 100, 160, .15);
      --text-primary: #1a1a1a;
      --text-secondary: rgba(26, 26, 26, .5);
      --bg-sidebar: #ffffff;
      --border-sidebar: rgba(20, 100, 160, .08);
      --bg-sidebar-hover: rgba(20, 100, 160, .05);
      --bg-sidebar-active: rgba(20, 100, 160, .1);
      --text-sidebar: rgba(26, 26, 26, .55);
      --text-sidebar-hover: #1a1a1a;
      --text-sidebar-active: #1464a0;
      --bg-content: #f0f7ff;
      --shadow-toolbar: 0 2px 20px rgba(0, 0, 0, .06);
      --shadow-sidebar: 4px 0 20px rgba(0, 0, 0, .04);
      --color-accent: #1464a0;
      --color-accent-light: #1a7fc4;
      --avatar-bg: rgba(20, 100, 160, .12);
      --avatar-text: #1464a0;
    }

    /* ═══ LIGHT THEME ═══ */
    .light {
      --bg-body: #f0f7ff;
      --bg-toolbar: rgba(255, 255, 255, .95);
      --border-toolbar: rgba(20, 100, 160, .1);
      --text-primary: #1a1a1a;
      --text-secondary: rgba(26, 26, 26, .45);
      --bg-sidebar: #ffffff;
      --border-sidebar: rgba(20, 100, 160, .06);
      --bg-sidebar-hover: rgba(20, 100, 160, .04);
      --bg-sidebar-active: rgba(20, 100, 160, .1);
      --text-sidebar: rgba(26, 26, 26, .5);
      --text-sidebar-hover: #1a1a1a;
      --text-sidebar-active: #1464a0;
      --bg-content: #f0f7ff;
      --shadow-toolbar: 0 2px 20px rgba(0, 0, 0, .04);
      --shadow-sidebar: 4px 0 20px rgba(0, 0, 0, .02);
      --color-accent: #1464a0;
      --color-accent-light: #1a7fc4;
      --avatar-bg: rgba(20, 100, 160, .12);
      --avatar-text: #1464a0;
    }

    /* ═══ TOOLBAR ═══ */
    .app-toolbar {
      position: fixed; top: 0; left: 0; right: 0; z-index: 100;
      height: 64px; padding: 0 24px;
      display: flex; align-items: center; gap: 12px;
      background: var(--bg-toolbar);
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      border-bottom: 1px solid var(--border-toolbar);
      box-shadow: var(--shadow-toolbar);
      transition: background var(--theme-transition), border var(--theme-transition);
    }

    .hamburger-btn {
      display: none; align-items: center; justify-content: center;
      width: 36px; height: 36px; border-radius: 8px;
      border: none; background: transparent;
      color: var(--text-primary); cursor: pointer;
      transition: background .2s;
    }
    .hamburger-btn:hover { background: var(--bg-sidebar-hover); }

    .toolbar-brand {
      font-size: 15px; font-weight: 700; color: var(--color-accent);
      letter-spacing: 1.5px; text-transform: uppercase;
    }

    .toolbar-spacer { flex: 1; }

    .toolbar-user {
      display: flex; align-items: center; gap: 8px;
      padding: 4px 12px 4px 4px; border-radius: 8px;
    }

    .user-avatar {
      width: 28px; height: 28px; border-radius: 6px;
      background: var(--avatar-bg); color: var(--avatar-text);
      display: flex; align-items: center; justify-content: center;
      font-size: 12px; font-weight: 700;
    }

    .user-name {
      font-size: 13px; font-weight: 500; color: var(--text-primary);
    }

    .toolbar-btn {
      width: 36px; height: 36px; border-radius: 8px;
      border: none; background: transparent;
      color: var(--text-secondary); cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      transition: all .2s;
    }
    .toolbar-btn:hover { background: var(--bg-sidebar-hover); color: var(--text-primary); }

    /* ═══ BODY ═══ */
    .app-body {
      display: flex; padding-top: 64px;
      min-height: 100vh;
      background: var(--bg-body);
      transition: background var(--theme-transition);
    }

    /* ═══ SIDEBAR ═══ */
    .app-sidebar {
      width: 240px; flex-shrink: 0;
      background: var(--bg-sidebar);
      border-right: 1px solid var(--border-sidebar);
      box-shadow: var(--shadow-sidebar);
      display: flex; flex-direction: column;
      height: calc(100vh - 64px); position: sticky; top: 64px;
      transition: background var(--theme-transition), border var(--theme-transition);
      z-index: 50;
    }

    .sidebar-header {
      display: flex; align-items: center; gap: 10px;
      padding: 20px 20px 16px;
      border-bottom: 1px solid var(--border-sidebar);
    }

    .sidebar-brand-icon {
      width: 32px; height: 32px; border-radius: 8px;
      overflow: hidden;
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0;
      img { width: 100%; height: 100%; object-fit: contain; }
    }

    .sidebar-brand-text {
      font-size: 11px; font-weight: 700; color: var(--text-primary);
      letter-spacing: 2px; text-transform: uppercase;
    }

    .sidebar-nav {
      flex: 1; overflow-y: auto; padding: 12px 12px 20px;
      display: flex; flex-direction: column;
    }

    .sidebar-group-label {
      font-size: 10px; font-weight: 600; color: var(--text-secondary);
      text-transform: uppercase; letter-spacing: 1.5px;
      padding: 16px 12px 6px;
    }

    .sidebar-link {
      display: flex; align-items: center; gap: 10px;
      padding: 10px 12px; margin-bottom: 1px;
      border-radius: 8px;
      text-decoration: none;
      color: var(--text-sidebar);
      font-size: 13px; font-weight: 500;
      transition: all .2s ease;
    }

    .sidebar-link:hover {
      background: var(--bg-sidebar-hover);
      color: var(--text-sidebar-hover);
    }

    .sidebar-link.active-link {
      background: var(--bg-sidebar-active);
      color: var(--text-sidebar-active);
      font-weight: 600;
    }

    .sidebar-link svg { flex-shrink: 0; }

    .sidebar-spacer { flex: 1; min-height: 8px; }

    .sidebar-overlay { display: none; }

    /* ═══ MAIN ═══ */
    .app-main {
      flex: 1; padding: 28px 32px;
      overflow-y: auto;
      background: var(--bg-content);
      transition: background var(--theme-transition);
    }

    /* ═══ MOBILE ═══ */
    @media (max-width: 768px) {
      .app-toolbar { padding: 0 12px; height: 56px; }
      .hamburger-btn { display: flex; }
      .user-name { display: none; }
      .app-body { padding-top: 56px; }
      .app-sidebar {
        position: fixed; top: 56px; left: -280px;
        width: 280px; height: calc(100vh - 56px);
        transition: left .35s cubic-bezier(.22, 1, .36, 1);
        z-index: 90;
      }
      .app-sidebar.open { left: 0; }
      .sidebar-overlay {
        display: block; position: fixed; inset: 0;
        background: rgba(0, 0, 0, .4);
        z-index: 80; opacity: 0; pointer-events: none;
        transition: opacity .35s ease;
      }
      .sidebar-overlay.open { opacity: 1; pointer-events: auto; }
      .app-main { padding: 20px 16px; }
    }
  `]
})
export class AppComponent implements OnInit {
  sidenavOpen = true;
  isMobile = false;
  isDark = false;

  constructor(public auth: AuthService, private router: Router, private dialog: MatDialog) { }

  ngOnInit() {
    if (this.auth.isLoggedIn() && this.router.url === '/login') {
      this.router.navigate(['/home']);
    }
    const saved = localStorage.getItem('theme');
    this.isDark = saved ? saved === 'dark' : true;
    this.checkScreenSize();
    window.addEventListener('resize', () => this.checkScreenSize());
  }

  isLanding() {
    const url = this.router.url;
    return url === '/' || url === '' || url.startsWith('/#') || url.startsWith('/?');
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
    if (this.isMobile) this.sidenavOpen = false;
  }

  toggleSidenav() { this.sidenavOpen = !this.sidenavOpen; }

  closeMobile() {
    if (this.isMobile) this.sidenavOpen = false;
  }

  toggleTheme() {
    this.isDark = !this.isDark;
    localStorage.setItem('theme', this.isDark ? 'dark' : 'light');
  }

  openAdminSecurity() {
    this.closeMobile();
    this.dialog.open(AdminSecurityDialogComponent, {
      width: '450px',
      disableClose: true
    });
  }
}
